<ag-grid-angular #coinsEarnedGrid *ngIf="coinsTable" class="ag-theme-material h-100 overflow-auto" [gridOptions]="coinsTable"></ag-grid-angular>